import { VoidBlock } from "../VoidBlock";

/**
 * Block for deleting a variable from the variable environment
 */
export class VarDeleteBlock extends VoidBlock{
    varName: string;

    /**
     * Constructor
     * @param varName variable name
     */
    constructor(id: string, varName:string){
        super(id)
        this.varName = varName;
    }

    /**
     * Deletes varName from variable environment if it exists.
     * @param varEnv variable environment
     */
    *evalBlock(varEnv:Map<string, any>){
        if(varEnv.has(this.varName)){
            varEnv.delete(this.varName);
        }
        yield;
    }
}